/**
 * Format a number
 * @param number Number
 * @returns Formatted number
 */
export function oldFormatNumber(number: number): string {
    if (number === undefined) {
        return "";
    }
    return number.toLocaleString("fr-FR");
}

/**
 * Format data for Rechart and have { value : XXX } for each value
 * @param data Object
 * @returns Formatted data with object with key value on each leaf
 */
type WrappedValue<T> =
    T extends Record<string, any> ? { [K in keyof T]: WrappedValue<T[K]> } : { value: T };

export function formatDataForChart<T>(obj: T): WrappedValue<T> {
    function wrapValues(obj: any) {
        for (const key in obj) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
                wrapValues(obj[key]);
            } else {
                obj[key] = { value: obj[key] };
            }
        }
    }

    const result = JSON.parse(JSON.stringify(obj));

    wrapValues(result);

    return result as WrappedValue<T>;
}
